import React, { useEffect, useRef, useState } from 'react';
import './Projects_relations.css';
import { add_project, get_projects, archive_project, get_project_opportunities } from '../../utils/services';
import {  useNavigate } from 'react-router-dom';

function Projects_relations  ({user_id, permission, usr_type}) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  // Orden por defecto: #T8 (count_serials) de mayor a menor
  const [sortedColumn, setSortedColumn] = useState('count_serials');
  const [sortOrder, setSortOrder] = useState('desc');

  //LIST OF SERIAL MEMBERS:
  const [searchTerm, setSearchTerm] = useState('');
  const [projects, setprojects] = useState([]);
  const [opportunitiesByProjectId, setOpportunitiesByProjectId] = useState({});
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newProjectName, setNewProjectName] = useState('');
  const [externalLicenseUntil, setExternalLicenseUntil] = useState(''); // YYYY-MM-DD





    // Función para manejar la búsqueda
    const filteredProjects = projects.filter((project) =>
      project.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortTable = (column) => {
      const isSameColumn = sortedColumn === column;
      // Por defecto: #T8 (count_serials) de mayor a menor; el resto de columnas ascendente.
      const nextOrder = isSameColumn
        ? (sortOrder === 'asc' ? 'desc' : 'asc')
        : (column === 'count_serials' ? 'desc' : 'asc');

      setSortedColumn(column);
      setSortOrder(nextOrder);
    };

    const getSortedProjects = () => {
      if (!sortedColumn) return filteredProjects;
      const order = sortOrder;
      return [...filteredProjects].sort((a, b) => {
        const valA = a[sortedColumn];
        const valB = b[sortedColumn];

        // Si los valores son numéricos (aunque vengan como string), ordenamos numéricamente.
        const numA = Number(valA);
        const numB = Number(valB);
        if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
          if (numA < numB) return order === 'asc' ? -1 : 1;
          if (numA > numB) return order === 'asc' ? 1 : -1;
          return 0;
        }

        // Caso texto (p.ej. name, country)
        if (typeof valA === 'string' && typeof valB === 'string') {
          return order === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        }

        if (valA < valB) return order === 'asc' ? -1 : 1;
        if (valA > valB) return order === 'asc' ? 1 : -1;
        return 0;
      });
    };

    const isLicensedExpired = (licensedUntil) => {
      if (!licensedUntil) return false;

      const s = String(licensedUntil).trim();
      const parts = s.split('-');
      if (parts.length < 3) return false;

      const [y, m, d] = parts.map((p) => parseInt(p, 10));
      if ([y, m, d].some((v) => Number.isNaN(v))) return false;

      const today = new Date();
      const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      const expUTC = Date.UTC(y, m - 1, d);

      // "Menor a la actual": estrictamente vencida antes de hoy
      return expUTC < todayUTC;
    };

    const usrTypeNum = parseInt(usr_type);
    const isInternalUser = usrTypeNum === 0;

  const refresh_projects_list = () => {
    async function fetchProjects() {
        const membersList = await get_projects(token);
        if (membersList==="INVALID"){
          navigate("/");
        }else{
         if (membersList!=null){
            const members = membersList.map((element, index) => {
              return {
                id: element.project_id,
                name: element.project_name,
                country: element.country,
                link_token: element.link_token,
                // Aseguramos numérico para que el orden por #T8 funcione correctamente.
                count_serials: Number(element.t8s ?? 0),
                count_opportunities: Number(element.opportunities ?? 0),
                licensed_until: element.licensed_until ?? null,
                creation_date: element.creation_date,
                owner_mail: element.owner_mail,
                index: index,
              };
            });

            setprojects(members);

            // Cargar nombres de oportunidades por proyecto.
            // Nota: el backend retorna {id, name} por oportunidad.
            const oppMap = {};
            await Promise.all(
              members.map(async (m) => {
                try {
                  const oppList = await get_project_opportunities(token, m.id);
                  if (oppList && oppList !== "INVALID" && Array.isArray(oppList)) {
                    oppMap[m.id] = oppList.map((o) => o?.name).filter(Boolean);
                  } else {
                    oppMap[m.id] = [];
                  }
                } catch {
                  oppMap[m.id] = [];
                }
              })
            );

            setOpportunitiesByProjectId(oppMap);
        }
                  
       }
      }
      fetchProjects();
  }

  const selectproject = (index, id) => {
      navigate("/project?id=" + id);
  };

  useEffect(() => {
    console.log("Permission: " + permission);
    refresh_projects_list();
  }, [token]); // Solo se vuelve a ejecutar si 'token' cambia


  
  const handleOpenAddModal = () => {
    setNewProjectName('');
    setExternalLicenseUntil('');
    setIsAddModalOpen(true);
  };

  const handleCloseAddModal = () => {
    setIsAddModalOpen(false);
  };

  const handleAddProjectSubmit = async (e) => {
    e?.preventDefault?.();
    const trimmedName = (newProjectName || '').trim();
    if (!trimmedName) return;

    const res = await add_project(token, {
      projectName: trimmedName,
      external_license_until: externalLicenseUntil || '',
    });

    if (res === "INVALID") {
      navigate("/");
      return;
    }

    handleCloseAddModal();
    refresh_projects_list();
  };

  const handleArchiveProject = async (projectId, projectName) => {
    if (!isInternalUser) return;
    const ok = window.confirm(`¿Seguro que deseas archivar el proyecto "${projectName}"?`);
    if (!ok) return;

    const res = await archive_project(token, projectId);
    if (res === "INVALID") {
      navigate("/");
      return;
    }

    refresh_projects_list();
  };


  return (
    
     <div className="container">
    
    <input
        type="text"
        placeholder="Buscar por nombre..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '10px', padding: '5px', width: '100%' }}
      />
      <div className="table-container2">

    

      <table className="version-table2">
        <thead>
          <tr>
            <th style={{ width: '25%', cursor: 'pointer' }} onClick={() => sortTable('name')}>
              Nombre {sortedColumn === 'name' ? (sortOrder === 'asc' ? '🔼' : '🔽') : ''}
            </th>
            <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => sortTable('country')}>
              País {sortedColumn === 'country' ? (sortOrder === 'asc' ? '🔼' : '🔽') : ''}
            </th>
            <th style={{ width: '5%', cursor: 'pointer' }} onClick={() => sortTable('count_serials')}>
              # T8 {sortedColumn === 'count_serials' ? (sortOrder === 'asc' ? '🔼' : '🔽') : ''}
            </th>
            {isInternalUser ? (
              <th style={{ width: '8%', cursor: 'pointer' }} onClick={() => sortTable('count_opportunities')}>
                Oportunidades {sortedColumn === 'count_opportunities' ? (sortOrder === 'asc' ? '🔼' : '🔽') : ''}
              </th>
            ) : null}
            <th style={{ width: '12%' }}>
              Licencia hasta
            </th>
            {isInternalUser ? <th style={{ width: '6%' }}>Archivar</th> : null}
          </tr>
        </thead>
        <tbody>
          {getSortedProjects().map((project, index) => {
            const rowIsExpired = isLicensedExpired(project.licensed_until);
            // Siempre navegable: en Project_admin el embed Looker se reemplaza por mensaje si externo + licencia vencida.

            return (
              <tr
                key={index}
                onClick={() => selectproject(index, project.id)}
                style={{ cursor: 'pointer' }}
              >
                <td>{project.name}</td>
                <td>{project.country}</td>
                <td>{project.count_serials}</td>
                {isInternalUser ? (
                  <td className="opportunities-cell">
                    {opportunitiesByProjectId[project.id] === undefined ? (
                      project.count_opportunities > 0 ? 'Cargando...' : '—'
                    ) : opportunitiesByProjectId[project.id].length > 0 ? (
                      <div className="opportunities-names">
                        {opportunitiesByProjectId[project.id].join(', ')}
                      </div>
                    ) : (
                      '—'
                    )}
                  </td>
                ) : null}
                <td className={rowIsExpired ? 'license-expired' : undefined}>
                  {project.licensed_until ?? '—'}
                </td>
                {isInternalUser ? (
                  <td className="project-actions-cell">
                    <button
                      type="button"
                      className="archive-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleArchiveProject(project.id, project.name);
                      }}
                      title="Archivar"
                      aria-label={`Archivar ${project.name}`}
                    >
                      <i className="bi bi-archive" aria-hidden="true" />
                    </button>
                  </td>
                ) : null}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>

    {permission === "1" ? (
      <>
        <button type="button" className="fab-add" onClick={handleOpenAddModal} aria-label="Agregar proyecto">
          +
        </button>

        {isAddModalOpen ? (
          <div className="pr-modal-overlay" role="dialog" aria-modal="true">
            <div className="pr-modal">
              <div className="pr-modal-header">
                <div className="pr-modal-title">Nuevo proyecto</div>
                <button type="button" className="pr-modal-close" onClick={handleCloseAddModal} aria-label="Cerrar">
                  ×
                </button>
              </div>

              <form onSubmit={handleAddProjectSubmit}>
                <label className="pr-modal-label">
                  Nombre del proyecto
                  <input
                    className="pr-modal-input"
                    type="text"
                    value={newProjectName}
                    onChange={(e) => setNewProjectName(e.target.value)}
                    autoFocus
                    required
                  />
                </label>

                <label className="pr-modal-label">
                  Licencia de uso externo hasta
                  <input
                    className="pr-modal-input"
                    type="date"
                    value={externalLicenseUntil}
                    onChange={(e) => setExternalLicenseUntil(e.target.value)}
                  />
                </label>

                <div className="pr-modal-actions">
                  <button type="button" className="pr-btn pr-btn-secondary" onClick={handleCloseAddModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="pr-btn pr-btn-primary" disabled={!newProjectName.trim()}>
                    Agregar
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : null}
      </>
    ) : null}
    </div>
  );
};

export default Projects_relations;
